import dayjs from 'dayjs';
export const geneRateDate = () => dayjs().format('YYYYMMDD_HHmmss');
export const textFirstNameFile = {
  exportUserGroup: 'DS_Nhom_Nguoi_Dung',
  exportUserManagement: 'DS_Nguoi_Dung',
  exportQuestionBank: 'Ngan_Hang_Cau_Hoi',
  templateUploadQuestionBank: 'Upload_DSCauHoi_NHCH',
  templateUploadQuestionInSurvey: 'Upload_DSCauHoi_BKS',
  exportSurveyList: 'DS_Danh_Sach_Bai_Khao_Sat',
  exportSurveyAllStaff: 'DSThanhVien',
  exportSurveyStaffNormal: 'DSThanhVien_Thuong_NV',
  exportSurveyGroup: 'DSThanhVien_Nhom',
  templateUploadSurveyStaffNormal: 'Upload_DSThanhVien_Thuong_NV',
  templateUploadSurveyStaff360: 'Upload_DSThanhVien360',
  templateUploadEvaluatedPeople360: 'Upload_NguoiDuocDanhGia',
  exportSurveyEvaluatedPeople360: 'DS_NguoiDuocDanhGia',
  exportSurveyStaff360: 'DSThanhVien_360',
  exportSurveyResults: 'Ket_Qua_Khao_Sat',
  exportSurveyPeople: 'DS_NguoiLamBaiKhaoSat',
  exportPeopleDoNotSurvey: 'DS_NguoiChuaLamBaiKhaoSat',
  exportSurveyReports: 'Ket_Qua_Khao_Sat',
};
export const requestUrl = {
  exportUserGroup: '/UserGroups/exportUserGroups',
  exportUserManagement: '/Users/exportUsers',
  exportQuestionBank: '/Questions/exportQuestions',
  exportSurveyList: '/Survey/exportSurveys',
  exportSurveyAllStaff: '/Survey/exportSurveyPeople',
  exportSurveyStaff: '/Survey/exportPersonal',
  exportSurveyGroup: '/Survey/exportGroup',
  templateUploadSurveyStaffNormal: '/Survey/exportSurveyPeopleTemplate',
  templateUploadSurveyStaff360: '/Survey/exportSurveyPeopleTemplate',
  templateUploadEvaluatedPeople360: '/Survey/exportPersonEvaluatedTemplate',
  exportSurveyEvaluatedPeople360: '/Survey/exportPersonEvaluated',
};
